import ResumeSection from "./ResumeSection";

function ResumeSections(){
    return(
        <>
            <ResumeSection section_label="Education"/>
            <ResumeSection section_label="Jobs"/>
        </>
    );

}

export default ResumeSections;